import React from 'react';
import { ExternalLink, Phone, MessageSquare, Clipboard } from 'lucide-react';

const ButtonsPreview = ({ buttons = [] }) => {
  if (!Array.isArray(buttons) || buttons.length === 0) return null;

  return (
    <div className="-mx-3 px-3 border-t border-gray-200 dark:border-gray-700 pt-3 space-y-1 divide-y divide-gray-200 dark:divide-gray-700">
      {buttons.map((b, i) => {
        const key = b.id || i;
        const text = b.text ||
          (b.type === 'URL'
            ? 'Visit website'
            : b.type === 'CALL'
            ? 'Call phone number'
            : b.type === 'COPY'
            ? 'Copy offer code'
            : b.type === 'COPY_CODE'
            ? 'Copy Code'
            : 'Quick reply');
        const commonBtnCls =
          'w-full bg-transparent dark:bg-transparent rounded-md inline-flex items-center justify-center gap-2 text-blue-500 dark:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition py-2';

        if (b.type === 'URL') {
          const href = b.url || '#';
          return (
            <a
              key={key}
              href={href}
              target="_blank"
              rel="noreferrer"
              className={commonBtnCls}
            >
              <ExternalLink className="h-4 w-4" />
              <span className="text-sm font-medium">{text}</span>
            </a>
          );
        }

        if (b.type === 'CALL') {
          const phone = b.phoneNumber || '';
          return (
            <a key={key} href={`tel:${phone}`} className={commonBtnCls}>
              <Phone className="h-4 w-4" />
              <span className="text-sm font-medium">{text}</span>
            </a>
          );
        }

        if (b.type === 'COPY' || b.type === 'COPY_CODE') {
          const sample = b.sample || '';
          return (
            <button
              key={key}
              type="button"
              onClick={() => {
                if (navigator?.clipboard) navigator.clipboard.writeText(sample);
              }}
              className={commonBtnCls}
            >
              <Clipboard className="h-4 w-4" />
              <span className="text-sm font-medium">{text}</span>
            </button>
          );
        }

        return (
          <button key={key} type="button" className={commonBtnCls}>
            <MessageSquare className="h-4 w-4" />
            <span className="text-sm font-medium">{text}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ButtonsPreview;
